export default __webpack_public_path__ + "static/media/i1.2efc0e8e.png";